import axios from 'axios'
import posthog from 'posthog-js'

import { logoutUser } from 'Actions/account_action'
import { store } from '../store.index'
import { setServicePage } from './website_actions'

function client() {
  axios.interceptors.request.use(
    async config => {
      let awsWafToken = localStorage.getItem('aws-waf-token')
      const rwgToken = localStorage.getItem('rwg_token')

      // If no token exists, fetch a new one
      if (!awsWafToken) {
        try {
          awsWafToken = await window.AwsWafIntegration.getToken()
          localStorage.setItem('aws-waf-token', awsWafToken)
        } catch (error) {
          posthog.capture('aws-waf-token-error', {
            message: error?.message ?? 'Failed to get AWS WAF token',
            status: error?.response?.status,
            url: config?.url
          })
          return Promise.reject(error)
        }
      }

      // Add headers to the request
      if (config.headers) {
        config.headers = {
          ...(config?.headers && { ...config?.headers }),
          'x-aws-waf-token': awsWafToken,
          ...(!config?.url?.includes('inbox') && {
            'x-rwg-token': rwgToken || ''
          })
        }
        if (config.data instanceof FormData) {
          config.headers['content-type'] = 'multipart/form-data'
        }
      }

      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    async response => {
      setServicePage(false)(store.dispatch)

      // Handle 202 status - fetch new token and retry
      if (response.status === 202) {
        try {
          // Fetch new AWS WAF token
          const newToken = await window.AwsWafIntegration.getToken()
          localStorage.setItem('aws-waf-token', newToken)

          // Update the original request headers with new token
          const originalRequest = response.config
          if (originalRequest.headers) {
            originalRequest.headers['x-aws-waf-token'] = newToken
          }

          // Retry the original request with new token
          console.log('🔄 Retrying request with new AWS WAF token')
          return axios(originalRequest)
        } catch (error) {
          posthog.capture('aws-waf-token-refresh-error', {
            message: error?.message ?? 'Failed to refresh AWS WAF token on 202',
            url: response?.config?.url
          })
          return Promise.reject(error)
        }
      }

      return response
    },
    error => {
      posthog.capture(error.name, {
        message: error?.message ?? 'Something went wrong!',
        status: error?.response?.status,
        url: error?.response?.config?.url
      })
      if (error.response?.status === 401) {
        logoutUser()(store.dispatch)
        window.location = '/login'
      } else if (error.response?.status === 503) {
        setServicePage(true)(store.dispatch)
      }
      return Promise.reject(error)
    }
  )

  return axios
}

export { client }
